module.exports = __webpack_public_path__ + "static/media/logo-elo.f634541f.svg";